module.exports = __webpack_public_path__ + "static/media/17.20ed087f.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/17.png
// module id = 1057
// module chunks = 0